.row {
  align-items: flex-start;
  gap: var(--mirai-ui-space-XXS);
}

.row.centered {
  align-items: center;
}
